import './App.css';
import React, { useState, useEffect } from 'react';
import { StepsViewer } from './components/StepsViewer';
import { Config } from './Config';
import Footer from './components/Footer';
import Header from './components/Header';
import API from './library/ApiManager'
import Loading from './components/Loading';
import Fatturazione from './components/steps/Fatturazione';
import MetodiPagamento from './components/steps/MetodiPagamento';
import OrdineCompletato from './components/steps/OrdineCompletato';
import Fnc from './library/Functions';
import {
  Routes,
  Route,
  useNavigate,
  useSearchParams
} from "react-router-dom";
import Basket from './components/Basket';
import ConfigurazioneSito from './components/steps/ConfigurazioneSito';


/**
 * Componente principale dell'applicazione Carrello.
 * Gestisce tutte le parti della pagina che sono modularizzate e separate in componenti secondari.
 * Nel file Confing.js della root, sono presenti impostazioni generali di primaria importanza per il funzionamento di tutte le parti.
 *
 * @version 1.0.0
 * @author [Davide Pirola]
 */
function App() {

  const [searchParams, setSearchParams] = useSearchParams();

  const [currStep, setCurrStep] = useState(null);
  const [user, setUser] = useState(null);
  const [bskType, setBskType] = useState(Fnc.BasketType.PAY);
  //const [basket, setBasket] = useState(null);
  const [selComm, setSelComm] = useState(null);
  const [loadingState, setLoadingState] = useState("open");
  //const [chooseCommStep, setChooseCommStep] = useState(false);
  //const [chooseDomainStep, setChooseDomainStep] = useState(false);
  const [invoice, setInvoice] = useState(null);
  const [payResult, setPayResult] = useState(null);
  const [validBasket, setValidBasket] = useState(true);
  const [customer, setCustomer] = useState(null);
  const [showBasket, setShowBasket] = useState(false);
  //const [basketProds, setBasketProds] = useState(false);

  const navigate = useNavigate();

  const defaultStep = Config.stepList.find(function (el) {
    return el.default;
  })

  useEffect(() => {

    Fnc.log("v."+Config.version, Fnc.currEnv().type, Fnc.LogLvl.INFO);

    // Similar to componentDidMount and componentDidUpdate:
    let defStep = Config.stepList.find(function (el) {
      return el.default;
    });
    setCurrStep(defStep);

    let courtesyTime = Fnc.checkState(1);

    if(courtesyTime) {
      navigate(Fnc.currEnv().courtesyPage);
    } else {
      jobFirstTimeLoad();
    }
   

  }, []); //empty array => chiama solo una volta. Senza la chiama ad ogni cambiamento

  function getSelComm() {
    return JSON.parse(sessionStorage.getItem(Fnc.selCCName));
  }


  function jobFirstTimeLoad() {

    let action = searchParams.get("action");
    Fnc.log("PARM PP:", action, Fnc.LogLvl.DEBUG);

    if (action && action !== null && action === 'pp') {
      //GESTIONE ULTIMO PASSO PAYPAL (acquisto in direct e redirect su pagina finale)

      let payPalRetData = searchParams.get("p");
      if (payPalRetData && payPalRetData !== null && payPalRetData.length > 0) {
        try {
          let ppRetObj = JSON.parse(payPalRetData);
          Fnc.log("PAYPAL PARAMS", ppRetObj, Fnc.LogLvl.DEBUG);
          if (ppRetObj.result === "OK") {
            //p={"result":"OK","billingId":"B-5H103545W4589520X","id":"8adc84f17ee1d10a017ee934d25c01e2","token":"EC-4DY95921VM479274U"}
            let payId = ppRetObj.id;
            let invoiceData = JSON.parse(sessionStorage.getItem(Fnc.invoiceName));
            invoiceData.gtw = 'pp';
            let fpt = Fnc.jsonSerialize(invoiceData);
            API.checkoutDirect(fpt, payId, (data) => {
              Fnc.log("CHECKOUT DIRECT OK", data, Fnc.LogLvl.DEBUG);
              setLoadingState("");
              if (data && data.response && data.response.code === 'OK') {
                setPayResult(new Fnc.Ret(Fnc.EnmPay.OKDIRECTPREV, data));
                setStep(12); //Riepilogo finale
              } else {
                Fnc.log("Checkout direct KO: ", data, Fnc.LogLvl.DEBUG);
                setStep(12); //Riepilogo finale
                Fnc.gaException("[App.js@jobFirstTimeLoad] Checkout direct KO paypal", payPalRetData, true, Fnc.ExcCatgory.PAYPAL.val);
              }
            });
          } else {
            setStep(-1);
            setLoadingState("");
            setShowBasket(false);
            Fnc.gaException("[App.js@jobFirstTimeLoad] Codice KO da Payapl" , payPalRetData, true, Fnc.ExcCatgory.PAYPAL.val);
          }

        } catch (e) {
          Fnc.log("Error parsing pp data", e, Fnc.LogLvl.DEBUG);
          setStep(-1);
          setLoadingState("");
          setShowBasket(false);
          Fnc.gaException("[App.js@jobFirstTimeLoad] Gestione ultimo step paypal non andata a buon fine", JSON.stringify(e), true, Fnc.ExcCatgory.PAYPAL.val);
        }

      } else {
        setStep(-1);
        setLoadingState("");
        setShowBasket(false);
        Fnc.gaException("[App.js@jobFirstTimeLoad] Ultimo step paypal senza dati sulla GET", null, true, Fnc.ExcCatgory.PAYPAL.val);
      }

    } else {
      //GESTIONE CARRELLO "NORMALE"

      //Apro loading per permettere il caricamento dell'eventuale utente loggato / altre procedure iniziali.
      setLoadingState("open");

      getUser();

    }
  }

  // === STEP2- [USER] : controllo utente e sue commissioni ========
  function getUser() {
    //Recuperiamo dati utente per verificare se è loggato e agire di conseguenza nel layout
    API.getUser((data) => {

      // in base ai dati utente ritornati setto gli stati per modificare il layout di conseguenza
      if ((data && data.user.commissionList && data.user.commissionList.commissions && data.user.commissionList.commissions.length > 1)) {
        // > 1 commissione
        setUser(data);
        setLoadingState("");
        // --- Leggo dal sessionStorage l'eventuale codice commissione settato in precedenza e gestisco il caso
        let selCodComm = getSelComm();
        let isCCSetted = selCodComm && selCodComm !== null;

        //check se il codice commissione settato nella sessione è tra quelli appartenenti all'utente
        let checkValidCcSetted = data.user.commissionList.commissions.find(c => {
          return selCodComm && selCodComm !== null && c.codComm === selCodComm.codComm;
        })

        if (isCCSetted && checkValidCcSetted && checkValidCcSetted !== null) {
          //Codice commissione già settato e valido

          let piva = data.user.pIva;
          API.getCustomer(piva, (custRsp) => {
            if (custRsp && custRsp.response && (custRsp.response.code === 'OK')) {
              setComm(selCodComm);
              setCustomer(custRsp);
              setLoadingState("");
              setShowBasket(true);
              //setChooseCommStep(false);
              

            } else {
              // ERRORE
              setStep(-1);
              setLoadingState("");
              setShowBasket(false);
              Fnc.gaException("[App.js@getUser]Get Customer ha dato esito KO: ", JSON.stringify(custRsp), true, Fnc.ExcCatgory.USER.val);
            }
          });

        } else {
          //Non ho un codice commissione settato, devo chiedere all'utente di inserirlo
          //setChooseCommStep(true);
          setShowBasket(false);
        }

        //--- 
      } else if (data && data.user.commissionList && data.user.commissionList.commissions && data.user.commissionList.commissions.length === 1) {
        // = 1 commissione
        setUser(data);
        let codComm = data.user.commissionList.commissions[0];
        sendCommToBE(codComm, () => {
          // === STEP3/A - [CUSTOMER] : chiamo la "customer" per settare la piva nel cookie. Deve essere sincronizzata! ========
          let piva = data.user.pIva;
          API.getCustomer(piva, (custRsp) => {
            if (custRsp && custRsp.response && (custRsp.response.code === 'OK')) {
              setComm(codComm);
              setCustomer(custRsp);
              setLoadingState("");
              setShowBasket(true);
              
            } else {
              // ERRORE
              setStep(-1);
              setLoadingState("");
              setShowBasket(false);
              Fnc.gaException("[App.js@getUser] Get Customer ha dato esito KO", JSON.stringify(custRsp), true, Fnc.ExcCatgory.USER.val);
            }
          });
        })
      } else if (data && data.user.commissionList && !data.user.commissionList.commissions ) {
        //16/5/2023 : caso nel quale la user non mi ritorna le commissioni, do messaggio apposito e non mostro pagina completata a metà
        setStep(-1);
        setLoadingState("");
        setShowBasket(false);
        Fnc.gaException("[App.js@getUser] Get User con commissionList ma senza commissions", null, true, Fnc.ExcCatgory.USER.val);
      } else {
        if (data) {
          // nessuna commissione
          setUser(data);
          setLoadingState("");
          setShowBasket(true);
        } else {
          // ERRORE
          setStep(-1);
          setLoadingState("");
          setShowBasket(false);
          Fnc.gaException("[App.js@getUser] Get User vuota: ", null, true, Fnc.ExcCatgory.USER.val);
        }
      }

    });
  }

  function sendCommToBE(comm, callback) {
    API.addValue("CODCOMM", comm.codComm, (data) => {
      if (!(data && data.response && data.response.code === 'OK')) {
        // ERRORE
        setStep(-1);
        Fnc.gaException("[App.js@sendCommToBE] Aggiunta codice commissione al cookie in KO", JSON.stringify(data), true, Fnc.ExcCatgory.GENERIC.val);
      }
      callback();
    });
  }

  function handleNext() {
    let stepByUrl = Fnc.getStepByUrl();
    let nextIdx = stepByUrl.idx + 1;
    setStep(nextIdx);
  }

  function setStep(idx) {
    let stepByUrl = Fnc.getStepByUrl();
    if (stepByUrl.idx !== idx) { // Prevengo doppie chiamate
      let selectedStep = Config.stepList.find(function (el) {
        return el.idx === idx;
      })
      setCurrStep(selectedStep);
      navigate(selectedStep.path);
    }
  }

  function setComm(comm) {
    //setto globalmente la commissione sulla risposta, altrimenti sarebbe vuota ma non verrebbe più fuori la scelta
    sessionStorage.setItem(Fnc.selCCName, JSON.stringify(comm));
    setSelComm(comm); //setto  anche nella variabile react perché la sessione si aggiorna in asincrono e a volte non lo fa in tempo
  }

  function handleChooseContract(comm) {

    sendCommToBE(comm, () => {

      // === STEP3/B - [CUSTOMER] : chiamo la "customer" per settare la piva nel cookie. Deve essere sincronizzata! ========
      let piva = user.user.pIva;
      API.getCustomer(piva, (custRsp) => {
        if (custRsp && custRsp.response && (custRsp.response.code === 'OK')) {
          setComm(comm);
          setCustomer(custRsp);
          setLoadingState("");
          setShowBasket(true);
        } else {
          // ERRORE
          setStep(-1);
          setLoadingState("");
          setShowBasket(false);
          Fnc.gaException("[App.js@handleChooseContract] Get Customer in KO", JSON.stringify(custRsp), true, Fnc.ExcCatgory.GENERIC.val);
        }
      });

    })
  }

  function callbackFatturazione(data) {
    if (data && data.code === Fnc.EnmGen.OK) {
      setInvoice(data.obj);
      //salvo in sessione i dati fatturazione. Serviranno in alcuni casi nei quali non si possono traferire facilmente
      sessionStorage.setItem(Fnc.invoiceName, JSON.stringify(data.obj));

      if (bskType === Fnc.BasketType.PAY || bskType === Fnc.BasketType.BOTH) {
        //Ho ANCHE dei prodotti che si possono acquistare direttamente
        handleNext();
      } else {
        //ho solo preventivi
        //setLoadingState("open");
        let fpt = Fnc.jsonSerialize(data.obj);

        API.checkoutDirect(fpt, "1111111111111", (data) => {
          Fnc.log("CHECKOUT DIRECT PREVENTIVI OK", data, Fnc.LogLvl.DEBUG);

          if (data && data.response && data.response.code === 'OK') {
            setPayResult(new Fnc.Ret(Fnc.EnmPay.OKDIRECTPREV, data));
            //setLoadingState("");
            setStep(12); //Riepilogo finale
          } else {
            Fnc.log("Checkout direct KO: ", data, Fnc.LogLvl.DEBUG);
            setStep(12); //Riepilogo finale
            Fnc.gaException("[App.js@callbackFatturazione] Checkout direct KO per solo preventivi", JSON.stringify(data), true, Fnc.ExcCatgory.API_CALL.val);
          }

        });

      }

    } else {
      Fnc.log("FATTURAZIONE KO", data, Fnc.LogLvl.DEBUG);
    }
  }

  function callbackMetodiPagamento(data) {
    if (data && (data.code === Fnc.EnmPay.OK || data.code === Fnc.EnmPay.OKDIRECT)) {
      setPayResult(data);
      handleNext();
    } else {
      Fnc.log("METODI PAGAMENTO KO", data, Fnc.LogLvl.DEBUG);
      Fnc.gaException("[App.js@callbackMetodiPagamento] METODI PAGAMENTO KO", JSON.stringify(data), true, Fnc.ExcCatgory.PAY_METHOD.val);
      handleNext();
    }
  }

  function callbackBasket(data) {

    Fnc.log("callbackBasket:", data, Fnc.LogLvl.DEBUG);

    // IMPORTANTE : salvo la tipologia di basket che serve a cambiare l'interfaccia in diversi punti a seconda se ho prodotti misti o solo pay / prev
    setBskType(data && data.obj && data.obj.type && data.obj.type !== null ? data.obj.type : Fnc.BasketType.PAY);

    //Salvo i prodotti messi nel carrello in sessione. N.B. lo faccio sempre se ce li ho, non solo se carrello è OK,  perché possono servire anche per i tracciamenti e per altre funzioni
    if (data.obj.bskAndProds) {
      sessionStorage.setItem(Fnc.prodListName, JSON.stringify(data.obj.bskAndProds));
    }

    if (data && data.code === Fnc.EnmBasket.OK) {
      setValidBasket(true);
      //setBasketProds(data.obj.bskAndProds); //salvo i prodotti del carrello per la pagina finale


      //setBasket(data.obj.data); 
    } else if (data && data.code === Fnc.EnmBasket.EMPTY_DOMAIN) {
      //sito web senza dominio, va mostrata pagina apposita
      //setBasket(data.obj.data); //salvo il carrello per usarlo nella pagina dominio (dovrò aggiornare properties e rimandare tutto)
      setStep(9); //scelta dominio
      //N.B. non metto il basket invalido perchè semplicemente manca il dominio
    } else if (data && data.code === Fnc.EnmBasket.EMPTY) {
      setValidBasket(false);
      setStep(-2); //carrello vuoto
    } else {
      setValidBasket(false);
    }
  }

  function isTimeToShowBasket() {
    let stepByUrl = Fnc.getStepByUrl();
    return stepByUrl ? stepByUrl.withBasket : false;
  }


  function callbackConfSito(data) {

    if (data.code === Fnc.EnmGen.OK) {
      //SITO accettato
      handleNext();
    } else {
      // ERRORE
      setStep(-1);
      Fnc.gaException("[App.js@callbackConfSito] KO dalla configurazione sito SDIY ", JSON.stringify(data), true, Fnc.ExcCatgory.GENERIC.val);
    }

  }

  //----------- RENDER -----------
  return (

    <>
      <Header />
      <StepsViewer currStep={currStep != null ? currStep : defaultStep} user={user} selComm={selComm} bskType={bskType} />
      <div className="iol-checkout-body row">
        <Routes>
          <Route path="/fill" element={<ConfigurazioneSito callback={callbackConfSito} />} />
          <Route path="/pay" element={<MetodiPagamento handleNext={callbackMetodiPagamento} validBasket={validBasket} invoiceData={invoice} user={user} />} />
          <Route path="/" element={<Fatturazione callback={callbackFatturazione} validBasket={validBasket} selComm={selComm} user={user} customer={customer} handleChooseContract={handleChooseContract} bskType={bskType} />} />
          <Route path="/end" element={<OrdineCompletato payResult={payResult} />} />
        </Routes>
        {(showBasket && isTimeToShowBasket()) && <Basket callback={callbackBasket} codComm={selComm} />}
      </div>
      <Footer />
      <Loading loadingState={loadingState} />
    </>

  );
}

export default App;
